import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(require("vue-moment"));

import "./assets/styles/global.scss";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: "places"
  },
  installComponents: true
});

Vue.use(VueGtag, {
  config: { id: "G-Y9RBCFF8VB" }
});

Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
